module.exports = __webpack_public_path__ + "Classroom@2x.eee5a930.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/pages/Classroom/images/Classroom@2x.png
// module id = 0dUj
// module chunks = 0